import { t } from '@/lib/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@ant-design/pro-components';
import { requireCanManageUsers } from '@/features/auth/session/guards';
import { RedisMonitor } from '@/features/monitor/redis/page';
import { useDocumentTitle } from '@/hooks/use-document-title';

export const Route = createFileRoute('/_authenticated/system/monitor/redis')({
  /** Monitoring remains administrator-only, matching the API's authorization boundary. */
  beforeLoad: async ({ context, location }) => {
    await requireCanManageUsers(context.queryClient, location.href);
  },
  component: RedisPage,
});

/** Read-only Redis status using the API's existing connection. */
function RedisPage() {
  useDocumentTitle(t('Redis 缓存'));
  return (
    <PageContainer
      header={{ title: t('Redis 缓存') }}
      content={t('查看 Redis 运行状态、内存占用与缓存命中情况')}
    >
      <RedisMonitor />
    </PageContainer>
  );
}
